import { Form } from 'formik';
import { FormikDebounce } from '../common/form/FormikDebounce';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { validations } from '../../utils/validations';
import { FormContainer } from '../common/form/FormContainer';
import { SubmitButton } from '../common/form/SubmitButton';
import { SectionHeader } from '../common/SectionHeader';
import { Modal as QcsModal } from '@mui/material';

import { QcsModalBox } from '../common/basic/QcsModalBox';
import { DatePicker } from '../common/form/DatePicker';
import { Input } from '../common/form/Input';
import { isDateDisabled } from '../../utils/date';
import { TrainingVersionDto } from '@api/models/training/TrainingVersionDto';
import { CopyVersionRequest } from '@api/models/version/CopyVersionRequest';
import { trainingVersionService } from '@api/services/services';
import { ShowError } from '../ShowError';
import { resources } from '@api/resources';

interface Props {
  versionToCopy?: TrainingVersionDto | null;
  onClose: () => void;
  reloadTrainingVersionList: () => void;
}

export const CopyVersionModal: FC<Props> = ({ versionToCopy, onClose, reloadTrainingVersionList }) => {
  const { t } = useTranslation();

  const handleSubmit = async (data: CopyVersionRequest) => {
    await trainingVersionService.copyTrainingVersion(versionToCopy!.id!, data);
    reloadTrainingVersionList();
    onClose();
  };

  return (
    <QcsModal open={!!versionToCopy} onClose={onClose}>
      <QcsModalBox>
        <SectionHeader title={'training.copy.addVersion'} />
        <FormikDebounce<CopyVersionRequest>
          initialValues={{
            validFrom: '',
            versionNote: '',
          }}
          validationSchema={Yup.object().shape({
            validFrom: validations.stringDateNotPastOrTodayRequired(t),
          })}
          onSubmit={handleSubmit}
        >
          <Form>
            <FormContainer>
              <DatePicker
                name="validFrom"
                label={t('training.validFrom')}
                required
                disablePast
                disableHighlightToday
                shouldDisableDate={isDateDisabled}
              />
              <Input name="versionNote" label={t('training.versionNote')} maxLength={250} multiline={true} rows={4} />

              <ShowError resource={resources.copyTrainingVersion} />
              <SubmitButton />
            </FormContainer>
          </Form>
        </FormikDebounce>
      </QcsModalBox>
    </QcsModal>
  );
};
